export enum ExportPdfColor {
  HeaderRowColor = "#2C3341",
  HeaderRowColorLight = "#F6F8FA",
  OddRowColor = "#424957",
  OddRowColorLight = "#FFFFFF",
  EvenRowColor = "#32363E",
  EvenRowColorLight = "FCFCFC",
  green = "#3A9D76",
  purple = "#895EC4",
  blueDark = "#18B5FA",
  blueLight = "#2B6DCF",
  yellow = "#E5BB4F",
  red = "#AC3B52",
  alternativeRowColor = "#364A59",
}

export enum ExportPdfColorInventory {
  HeaderRowColor = "#EEEEEE",
  OddRowColor = "#F8F8F8",
  EvenRowColor = "#EEEEEE",
  green = "#3A9D76",
  purple = "#895EC4",
  blueDark = "#18B5FA",
  blueLight = "#2B6DCF",
}

export enum ExportExcelColor {
  HeaderRowColor = "2C3341",
  HeaderRowColorLight = "F6F8FA",
  OddRowColor = "424957",
  EvenRowColor = "303e5b",
  green = "3A9D76",
  purple = "895EC4",
  blueDark = "18B5FA",
  blueLight = "2B6DCF",
  yellow = "E5BB4F",
  red = "AC3B52",
  alternativeRowColor = "364A59",
  white = "FFFFFF",
}

export enum ExportExcelColorInventory {
  HeaderRowColor = "EEEEEE",
  OddRowColor = "F8F8F8",
  EvenRowColor = "EEEEEE",
  green = "3A9D76",
  purple = "895EC4",
  blueDark = "18B5FA",
  blueLight = "#2B6DCF",
}
